export default "__VITE_ASSET__BWAQOD9c__"